import Header from "../components/Header";
import AreasOfExpertise from "../components/Homesections/areaofexperties";
// import ConsultationCTA from "../components/Homesections/cta";
import WhyTrustUs from "../components/Homesections/lastsection";
import Aboutus from "../components/aboutus";
import CTASection from "../components/CTA";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import Banner from "../components/layout/Banner";
const About = ()=>{
    return(
        <>
        <Helmet> <title>About Us - Dr vibha Clinic | IVF & Fertility Specialist</title> <meta name="description" content="Learn about Dr Meenu’s Clinic, a trusted IVF and fertility center dedicated to helping couples achieve parenthood. Discover our expertise, advanced treatments, and compassionate care." /> <meta name="keywords" content="Dr Meenu Clinic, IVF center, fertility clinic, infertility treatment, IVF specialist, fertility doctor, parenthood treatment" /> <meta name="author" content="Dr Meenu’s Clinic" /> <meta name="robots" content="index, follow" /> {/* Open Graph for social sharing */} <meta property="og:title" content="About Dr Meenu’s Clinic | IVF & Fertility Specialist" /> <meta property="og:description" content="Discover Dr Meenu’s Clinic, a leading fertility center offering advanced IVF treatments and compassionate care to help you achieve your dream of parenthood." /> <meta property="og:type" content="website" /> </Helmet>
        <Header/>
         <Banner
        title="About US"
        subtitle="Expert Care for Pregnancy, Motherhood & Women's Health"
        image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg/1280px-A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg"
      />
        <Aboutus/>
        <AreasOfExpertise/>
        {/* <ConsultationCTA/> */}
        <WhyTrustUs/>
          <CTASection
        title="Take One Step Closer To"
        highlight="Parenthood"
        description="Every journey to becoming a parent is unique. At Dr Vibha Clinic, we combine care, expertise, and technology to give you the best chance of success."
        buttonText="BOOK YOUR APPOINTMENT"
        buttonLink="/contact-us"
      />
      {<Footer/>}
        </>
    )
}

export default About;